class BESSAppNavSearch extends BESSAppComponent {

    constructor() {
        super('.app-nav-search');
    }

    setupComponent(componentNode) {
        this.searchInput = componentNode.find('input');
        this.searching = componentNode.find('.app-searching');
        this.showAll = componentNode.find('.app-show-all-results');
        this.noResults = componentNode.find('.app-search-no-results');
        this.noResults.hide();
        this.searchResults = componentNode.find('.app-search-results-contents');
        this.searchResultsInner = componentNode.find('.app-search-results-nav');
        this.searchInput.onTypeAheadChange(this, this.#doSearch);
        this.searchingOn = null;
        $('.app-search-trigger').on('shown.bs.dropdown', function () {
            setTimeout(function () {
                this.searchInput.focus();
            }.bind(this), 100);
        }.bind(this));
    }

    #doSearch() {
        let searchInputVal = this.searchInput.val().trim();
        if (searchInputVal.length > 0) {
            if (this.searchingOn !== searchInputVal) {
                this.searchingOn = searchInputVal;
                this.searching.show();
                this.searchResults.hide();
                BESSApp.instance.services.api.search(searchInputVal, this.#onSearchResults.bind(this));
            }
        } else {
            this.searchingOn = null;
            this.searching.hide();
            this.searchResults.hide();
        }
    }

    #onSearchResults(response) {
        this.searching.hide();
        this.searchResultsInner.empty();
        this.hasResults = false;
        this.forEach(response.results, this.#onSearchResultSection)
        if (this.hasResults) {
            this.noResults.hide();
            this.searchResults.fadeIn();
        } else {
            this.noResults.fadeIn();
            this.searchResults.hide();
        }

    }

    #onSearchResultSection(resultSection) {
        this.showAll.hide();

        if (resultSection.results.length > 0) {
            this.showAll.attr('href', '/app/search?search=' + encodeURIComponent(this.searchingOn));

            let header = $('<div></div>').addClass('app-result-type').text(resultSection.type);
            this.searchResults.append(header);
            let results = resultSection.results;
            let hasMore = false;
            let nMore = 0;
            if (results.length > 3) {
                nMore = results.length - 3;
                results = results.splice(0, 3);
                hasMore = true;
            }
            this.forEach(results, function (result) {
                this.hasResults = true;
                let resultNodeLink = $('<a></a>').text(result.title).attr('href', result.url);
                let resultNode = $('<div></div>').addClass('app-result-item');
                resultNode.append(resultNodeLink);
                this.searchResults.append(resultNode);
            });
            if (hasMore) {
                this.showAll.show();
                let moreNode = $('<div></div>').addClass('app-result-item').addClass('more')
                    .text("Plus " + nMore + " more item" + (nMore > 4 ? 's.' : '.'));
                this.searchResults.append(moreNode)
            }
        }
    }

}
